<template>
    <comment-body :comment="comment">
        <a-button v-if="!comment.locked" type="link" @click="triggerWriteboard()">{{ open ? '收起回复' : '回复' }}</a-button>
        <a-button v-if="userid == comment.author.id" type="link" @click="editcomment()">编辑</a-button>
        <a-button v-if="userid == comment.author.id" type="link" @click="deleteComment()">删除</a-button>
        <a-button class="admin-button" v-else-if="hasDeletePrivilege" type="link" @click="deletecommentByAdmin()">删除</a-button>
        <a-dropdown v-if="commentBoard.canManage" :trigger="['click']">
            <a class="admin-button ant-dropdown-link" @click="e => e.preventDefault()">
                管理<a-icon type="down" />
            </a>
            <a-menu slot="overlay">
                <a-menu-item v-for="item of commentBoard.manageItems" :key="item.key">
                    <a href="javascript:;"
                        @click="commentBoard.manageThread(item.key)"
                    >{{ item.text[comment[item.key]] }}</a>
                </a-menu-item>
            </a-menu>
        </a-dropdown>
        <div slot="append" v-if="comment.replies.length > 0 || open">
            <a-list
                size="small"
                class="subcomment-list"
                item-layout="horizontal"
                :data-source="replies"
            >
                <div slot="header" />
                <a-list-item slot="renderItem" slot-scope="reply">
                    <Subcomment :parent="comment" :reply="reply" @reply="openWriteboard"></Subcomment>
                </a-list-item>
                <div class="writeboard" v-if="open">
                    <a-textarea v-model="text" ref="writeboard" auto-size></a-textarea>
                    <div class="textbar">
                        <a-button type="primary" size="small" @click="appendSubcomment()"
                            :loading="replying"
                        >发送</a-button>
                    </div>
                </div>
            </a-list>
        </div>
    </comment-body>
</template>

<script>
import CommentBody from './CommentBody.vue';
import Subcomment from './Subcomment.vue';
import { mapState } from 'vuex';
import { checkPrivilege } from '../../admin/privilege';

export default {
    props: {
        comment: Object,
    },
    data: () => ({
        open: false,
        text: "",
        replyto: 0,
        replying: false,
    }),
    inject: [ 'commentBoard' ],
    computed: {
        ...mapState({ userid: 'userid', userPrivilege: 'privilege' }),
        replies() {
            return this.comment.replies;
        },
        needPackup() {
            return this.comment.replies.length > 5;
        },
        hasDeletePrivilege() {
            return checkPrivilege({ comment: 3 }, this.userPrivilege);
        },
    },
    methods: {
        triggerWriteboard() {
            this.open = !this.open;
            if (this.open) {
                this.focusWriteboard();
            }
        },
        openWriteboard(reply) {
            this.open = true;
            if (reply) {
                this.replyto = reply.id;
                this.text = `Re #${reply.id}: `;
            } else {
                this.text = '';
            }
            this.focusWriteboard();
        },
        focusWriteboard() {
            this.$nextTick(() => {
                this.$refs.writeboard.focus();
            })
        },
        manageThread() {
            this.$emit('manage');
        },
        async appendSubcomment() {
            this.replying = true;
            const { comment: { id: pid }, text: content, replyto } = this;
            await this.commentBoard.appendComment({
                pid, content, replyto
            });
            this.replying = false;
        },
        editcomment() {
            this.$emit('edit', this.comment);
        },
        async deleteComment() {
            const { id } = this.comment;
            await this.commentBoard.deleteComment(id);
        },
        async deleteCommentByAdmin() {
            const { id } = this.comment;
            await this.commentBoard.deleteCommentByAdmin(id);
        },
    },
    components: {
        Subcomment, CommentBody,
    }
}
</script>

<style lang="less" scoped>
.subcomment-list {
    margin-left: 20px;
}
.writeboard {
    margin: 10px 15px;
    .ant-input {
        margin-bottom: 5px;
    }
    .textbar {
        .counter {
            &.warn {
                color: red;
            }
            margin: 0 5px;
        }
        .ant-btn {
            span {
                margin: 0px 10px;
            }
        }
        text-align: right;
    }
}
.admin-button {
    color: grey;
}
</style>

<style scoped>
.subcomment-list >>> .ant-list-header {
    padding: 0;
}
</style>
